import equal from "deep-equal";

import type { Comparator } from "~/shared/types";

export const removeFromSorted = (sortedDuids: string[], duid: string) => {
  const index = sortedDuids.indexOf(duid);
  if (index === -1) {
    return;
  }
  sortedDuids.splice(index, 1);
};

export const updateInSorted = <T extends { duid: string }>(
  duidsToObjects: Map<string, T>,
  sortedDuids: string[],
  newDuid: string,
  comparator: Comparator<T>
) => {
  removeFromSorted(sortedDuids, newDuid);

  const newEntry = duidsToObjects.get(newDuid);
  if (!newEntry) {
    return;
  }

  const insertIndex = sortedDuids.findIndex((duid) => {
    const existingEntry = duidsToObjects.get(duid);
    if (!existingEntry) {
      return false;
    }
    return comparator(newEntry, existingEntry) < 0;
  });

  if (insertIndex === -1) {
    sortedDuids.push(newDuid);
  } else {
    sortedDuids.splice(insertIndex, 0, newDuid);
  }
};

export const setObjectMapAndSorted = <T extends { duid: string }>(
  duidsToObjects: Map<string, T>,
  sortedDuids: string[],
  newObjects: T[],
  comparator: Comparator<T>
) => {
  const newIds = new Set(newObjects.map((e) => e.duid));
  Array.from(duidsToObjects.keys()).forEach((id) => {
    if (newIds.has(id)) {
      return;
    }
    duidsToObjects.delete(id);
  });
  newObjects.forEach((obj) => {
    const existingObj = duidsToObjects.get(obj.duid);
    if (equal(existingObj, obj, { strict: true })) {
      return;
    }
    duidsToObjects.set(obj.duid, obj);
  });

  const newSortedKeys = [...newObjects].sort(comparator).map((e) => e.duid);
  sortedDuids.splice(0, sortedDuids.length, ...newSortedKeys);
};
